import React, { FunctionComponent } from "react";

import { Link, Scheme, Text } from "@multiweb/reactComponents";
import { bridge } from "@multiweb/reactCore/bridge";

const { isUrl, isEmail, isFile } = bridge;

type LinkAttributeProps = {
    /** Adresa odkazu */
    value: string;
};
/** Komponenta, která vykresluje LinkAttribute. Pokud je hodnota platný odkaz, zobrazí se jako odkaz. V opačném případě jako text */
export const LinkAttribute: FunctionComponent<LinkAttributeProps> = ({
    value,
}) => {
    return (
        isUrl(value) || isEmail(value) || isFile(value)
            ? <Link
                url={value}
                defaultScheme={isEmail(value) ? Scheme.mailTo : isFile(value) ? Scheme.file : Scheme.https }
            />
            : <Text ellipsis={true} value={value} title={value} />
    );
};
